export default __webpack_public_path__ + "static/media/icon_arrow_right_24x24.c9b69f5d.svg";